/*  ========================================================================
    # Scripts - Social Proof
    ========================================================================  */

/**
 * Script that handles the marquee logic of the social proof section (variant 9.0).
 */
const SocialProof = {
  cfg: {
    sections: document.querySelectorAll('.s-social-proof[data-variant="9.0"]'),
    selectors: {
      container: '.s-social-proof__entries-container',
      entryWrapper: '.s-social-proof__entries',
      regularEntries: '.s-social-proof__entry-wrapper:not(.s-social-proof__entry-wrapper--duplicate)'
    }
  },

  /**
   * React to individual section resizing
   */
  resizeSection(section) {
    // Get a handle for both the container and entries
    const container = section.querySelector(this.cfg.selectors.container);
    const containerStyle = getComputedStyle(container);
    const entryWrapper = section.querySelector(this.cfg.selectors.entryWrapper);
    const regularEntries = section.querySelectorAll(this.cfg.selectors.regularEntries);

    // Calculate the size of the container and of the REGULAR entries to determine if the marquee should be active
    const containerWidth = container.offsetWidth - parseFloat(containerStyle.paddingLeft) - parseFloat(containerStyle.paddingRight);
    const regularEntriesWidth = [...regularEntries].map(entry => entry.offsetWidth).reduce((acc, width) => acc + width, 0);
    const shouldMarquee = regularEntriesWidth > containerWidth;
    entryWrapper.setAttribute('data-marquee', shouldMarquee);

    if (shouldMarquee) {
      // Update the css variable --calculated-marquee-duration on .s-social-proof to match the desired animation speed (given by --marquee-speed in pixels per second)
      const marqueeSpeed = parseFloat(getComputedStyle(section).getPropertyValue('--marquee-speed')) || 50; // Default to 50 if not set
      const duration = regularEntriesWidth / marqueeSpeed;
      section.style.setProperty('--calculated-marquee-duration', `${duration}s`);
    } else {
      // If the marquee is not needed, reset the duration to 0
      section.style.setProperty('--calculated-marquee-duration', '0s');
    }
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.sections) {
      // Create resize observer for each section
      for (const section of this.cfg.sections) {
        const observer = new ResizeObserver(elems => {
          this.resizeSection(elems[0].target);
        });
        observer.observe(section);
      }
    }
  }
};

export default SocialProof;
